<script setup>
import { computed } from 'vue';
const { strong } = defineProps({
  // Use strong prop when this dropdown is stacked inside another dropdown
  // Chrome has issues with stacked backdrop-blur, so we need an opaque surface when stacked
  // Also, stacked dropdowns should have a strong border
  strong: {
    type: Boolean,
    default: false,
  },
});

const borderClass = computed(() => {
  return strong ? 'border-n-strong' : 'border-n-weak';
});

const surfaceClass = computed(() => {
  if (strong) {
    // Opaque surface so content behind (e.g. dialog body) does not show through
    return 'bg-n-solid-1 shadow-lg';
  }
  return 'bg-n-alpha-3 backdrop-blur-[100px] shadow-sm';
});
</script>

<template>
  <div class="absolute">
    <ul
      class="text-sm border rounded-xl py-2 n-dropdown-body gap-2 grid list-none px-2 reset-base relative"
      :class="[borderClass, surfaceClass]"
    >
      <slot />
    </ul>
  </div>
</template>
